import {
  Flex,
  Text,
  Box,
  Tabs,
  TabList,
  TabPanels,
  Avatar,
  HStack,
  Tab,
  TabPanel,
  Stack,
  StackDivider,
  Image,
  SimpleGrid,
  Button,
  IconButton,
} from "@chakra-ui/react";
import React from "react";
import { BsStarFill } from "react-icons/bs";
import FreelancerCard from "../../marketplaceCategory/FreelancerCard";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { Link } from "react-router-dom";

export default function TabsHandler() {
  const [tab, setTab] = React.useState("All Gigs");
  const tabBtnListRef = React.useRef();
  const prevSelected = () => {
    let newSelection = tabListData.indexOf(tab);

    return tabListData[
      newSelection === 0 ? tabListData.length - 1 : newSelection - 1
    ];
  };
  const prevClickHandler = () => {
    let indexOfPrev = tabListData.indexOf(tab);
    let newIndexOfPrev =
      indexOfPrev === 0 ? tabListData.length - 1 : indexOfPrev - 1;
    setTab(tabListData[newIndexOfPrev]);
    tabBtnListRef.current.children[newIndexOfPrev].click();
  };
  const nextSelected = () => {
    let newSelection = tabListData.indexOf(tab);

    return tabListData[
      newSelection === tabListData.length - 1 ? 0 : newSelection + 1
    ];
  };
  const nextClickHandler = () => {
    let indexOfPrev = tabListData.indexOf(tab);
    let newIndexOfPrev =
      indexOfPrev === tabListData.length - 1 ? 0 : indexOfPrev + 1;
    setTab(tabListData[newIndexOfPrev]);
    tabBtnListRef.current.children[newIndexOfPrev].click();
  };
  return (
    <Box py={10}>
      <Tabs variant="unstyled" borderRadius={10} overflow="hidden">
        <Flex
          pos="relative"
          display={{ base: "flex", md: "none" }}
          justifyContent={"center"}
          overflow="hidden"
        >
          <Box
            fontSize="12px"
            _selected={{ color: "white", bg: "brand.500" }}
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="120px"
            rounded="none"
            px={1}
            textAlign={"center"}
          >
            {prevSelected()}
          </Box>
          <Box
            fontSize="12px"
            rounded="none"
            bg="brand.500"
            color="white"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            px={1}
            minW="120px"
            textAlign="center"
          >
            {tab}
          </Box>
          <Box
            fontSize="12px"
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="120px"
            px={1}
            textAlign={"center"}
            rounded="none"
            overflow="hidden"
            wordBreak={"break-word"}
          >
            {nextSelected()}
          </Box>
          <IconButton
            pos="absolute"
            left="0"
            height="full"
            background={"none"}
            _hover={{
              bgGradient:
                "linear(to-r,rgba(241,241,241,100)20%,rgba(241,241,241,0))",
            }}
            borderBottom="1px"
            rounded="none"
            borderColor="#c5c5c5"
            justifyContent="start"
            bgGradient="linear(to-r,rgba(241,241,241,100)20%,rgba(241,241,241,0))"
            w="50px"
            pr={1}
            onClick={prevClickHandler}
          >
            <AiOutlineLeft />
          </IconButton>
          <IconButton
            pos="absolute"
            right={0}
            justifyContent="end"
            m={0}
            height="full"
            background={"none"}
            _hover={{
              bgGradient:
                "linear(to-r,rgba(241,241,241,0)30%,rgba(241,241,241,100)70%)",
            }}
            borderBottom="1px"
            rounded="none"
            borderColor="#c5c5c5"
            bgGradient="linear(to-r,rgba(241,241,241,0)30%,rgba(241,241,241,100)70%)"
            w="50px"
            pr={1}
            onClick={nextClickHandler}
          >
            <AiOutlineRight />
          </IconButton>
        </Flex>
        <TabList
          overflow="auto"
          ref={tabBtnListRef}
          display={{ base: "none", md: "flex" }}
          justifyContent="center"
        >
          {tabListData.map((item) => {
            return (
              <Tab
              key={item}
                _selected={{ color: "white", bg: "brand.500" }}
                bg="#f1f1f1"
                maxW="300px"
                border="1px solid #c5c5c5"
                fontWeight={"semibold"}
                sx={{ py: 4 }}
                borderTopLeftRadius={10}
                minW="160px"
                onClick={() => {
                  setTab(item);
                }}
              >
                {item}
              </Tab>
            );
          })}
        </TabList>
        <TabPanels>
          <TabPanel p={0}>
            <Box p={{ base: 4, md: 8 }} color="#676767">
              <SimpleGrid columns={{ base: 1, sm: 2, lg: 3, xl: 4 }} gap={8}>
                {data.map((item) => (
                  <FreelancerCard
                    title={item.title}
                    key={item.title}
                    description={item.description}
                    coverImageUrl={item.coverImageUrl}
                    profileImageUrl={item.profileImageUrl}
                    verified={item.verified}
                    online={item.online}
                    price={item.price}
                    level={item.level}
                  />
                ))}
                <Stack
                  gap={2}
                  justifyContent="center"
                  alignItems="center"
                  bg="#f4f4f4"
                  border="1px solid #c5c5c5"
                  borderRadius={10}
                  minH="300px"
                >
                  <Image src="/images/freelancer/dashboard/create-gig.png" />
                  <Link to="/freelancer/gig/create">
                    <Text
                      color="brand.500"
                      fontSize="20px"
                      fontWeight="semibold"
                      cursor="pointer"
                    >
                      Create A Gig
                    </Text>
                  </Link>
                </Stack>
              </SimpleGrid>
            </Box>
          </TabPanel>
          <TabPanel p={0}>
            <Stack
              divider={<StackDivider />}
              w="max-content"
              p={5}
              alignItems={"center"}
              mx="auto"
            >
              {["", "", "", "", ""].map((item, index) => {
                return (
                  <Box py={10} px={6} key={index}>
                    <Flex gap={4} alignItems="center">
                      <Avatar
                        src="/images/gigImage/review.png"
                        size={{ base: "xl" }}
                      />
                      <Stack>
                        <HStack alignItems={"center"} gap={2}>
                          <Text
                            fontSize={{ base: "12px", md: "16px", xl: "19px" }}
                            fontWeight={"medium"}
                          >
                            Nath2015
                          </Text>
                          <Flex
                            color={"#ffbe5b"}
                            gap={1}
                            alignItems="center"
                            fontSize={{ base: "12px", xl: "16px" }}
                          >
                            <BsStarFill />
                            <BsStarFill />
                            <BsStarFill />
                            <BsStarFill />
                            <BsStarFill />
                            <Text>5</Text>
                          </Flex>
                        </HStack>
                        <Text
                          fontWeight={"semibold"}
                          color="gray.500"
                          fontSize={{ base: "13px", xl: "16px" }}
                        >
                          I asked for some logos for my new publishing company
                          and I am very pleased with the results
                        </Text>
                      </Stack>
                    </Flex>
                  </Box>
                );
              })}
            </Stack>
          </TabPanel>
          {/* Portfolio panel */}
          <TabPanel p={0}>
            <Stack py={20} px={10} gap={5} alignItems="center">
              <Image
                src="/images/gigImage/portfolio.png"
                maxW={{ base: "120px", md: "150px", xl: "180px" }}
              />
              <Text
                fontSize={{ base: "18px", xl: "28px" }}
                color="#8f8f8f"
                fontWeight="medium"
              >
                No Contracts In Progress
              </Text>
            </Stack>
          </TabPanel>
          <TabPanel p={0}>
            <Stack py={20} px={10} gap={5} alignItems="center">
              <Image
                src="/images/gigImage/portfolio.png"
                maxW={{ base: "120px", md: "150px", xl: "180px" }}
              />
              <Text
                fontSize={{ base: "18px", xl: "28px" }}
                color="#8f8f8f"
                fontWeight="medium"
              >
                No Completed Projects
              </Text>
            </Stack>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
const data = [
  {
    title: "Tim John",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-3.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-3.png",
    // verified: true,
    online: false,
    price: 20,
    level: "top",
  },
  {
    title: "Josh Gibbons",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-4.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-4.png",
    // verified: false,
    online: true,
    price: 20,
    level: 1,
  },
];
const tabListData = [
  "All Gigs",
  "Reviews (2k)",
  "Contacts in Progress (3)",
  "Completed Jobs (10)",
];
